import {HTMLAttributes, useCallback, useEffect, useState} from "react";
import './Invoice.scss';
import {Button, Col, Container, Modal, Row, Spinner} from "react-bootstrap";
import {formatDate} from "../../Utils/formatDate";
import {Link} from "react-router-dom";
import {api} from "../../services/Api";
import {useAlert} from "../../contexts/AlertContext";
import {useAuth} from "../../contexts/AuthenticationContext";
import QRCode from "react-qr-code";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {copyToClipboard} from "../../Utils/copyToClipboard";

interface InvoiceProps extends HTMLAttributes<HTMLDivElement> {
	invoice: {
		baixado: number;
		boleto: number;
		cobranca_entrada_confirmada: number;
		id_cobranca_registro_lancamento: number;
		data_vencimento: string;
		id: number;
		id_status: number;
		numero_contrato: string;
		numero_documento: string;
		plano: string;
		status: string;
		valor_documento: number;
		valor_juros: number;
		valor_multa: number;
		valor_total: number;
	};
}

export function Invoice({invoice}: InvoiceProps) {

	const { session } = useAuth();

	const { handleSetAlert } = useAlert();

	const [buttonInvoice, setButtonInvoice] = useState<any>(<></>);
	const [invoiceColorBorder, setInvoiceColorBorder] = useState<string>('');
	const [invoiceColor, setInvoiceColor] = useState<string>('');
	const [loadingDowloadBoleto, setLoadingDowloadBoleto] = useState<boolean>(false);
	const [loadingLinhaDigitavelBoleto, setLoadingLinhaDigitavelBoleto] = useState<boolean>(false);
	const [loadingQrCodeBoleto, setLoadingQrCodeBoleto] = useState<boolean>(false);

	const [pixModal, setPixModal] = useState<boolean>(false);
	const [pixModalQRCODE, setPixModalQRCODE] = useState<string | null>(null);

	let date = new Date();
	let actualDate = '';
	actualDate = (date.getFullYear()+""+("0"+(date.getMonth()+1)).substr(-2));

	const downloadBoleto = useCallback( (id: number) => {
		if(session){
			setLoadingDowloadBoleto(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/pessoas/clientes/boleto/'+id, {responseType: 'blob' , headers })
				.then((response) => {
					let newBlob = new Blob([response.data], {type: "application/pdf"})

					const data = window.URL.createObjectURL(newBlob);
					let link = document.createElement('a');
					link.href = data;
					link.download="NetComet_Boleto_"+id+".pdf";
					link.click();
					setTimeout(function(){
						window.URL.revokeObjectURL(data);
					}, 100);
					handleSetAlert({
						visible: true,
						variant: 'success',
						message: 'Boleto baixado com sucesso!',
						timeout: 5000
					});
					setLoadingDowloadBoleto(false);
				}).catch(() => {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: 'Problema ao baixar o arquivo',
					timeout: 5000
				});
				setLoadingDowloadBoleto(false);
			});
		}
	}, [handleSetAlert, session])

	const downloadLinhaDigitavelBoleto = useCallback( (id: number) => {
		if(session){
			setLoadingLinhaDigitavelBoleto(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/pessoas/clientes/linha-digitavel-boleto/'+id, { headers })
				.then((response: any) => {
					try {
						copyToClipboard(response.data.dados);
						handleSetAlert({
							visible: true,
							variant: 'success',
							message: 'Código copiado com sucesso!',
							timeout: 5000
						});
						setLoadingLinhaDigitavelBoleto(false);
					} catch (e) {
						handleSetAlert({
							visible: true,
							variant: 'danger',
							message: 'Problema ao buscar código do boleto',
							timeout: 5000
						});
						setLoadingLinhaDigitavelBoleto(false);
					}
				}).catch(() => {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: 'Problema ao buscar código do boleto',
						timeout: 5000
					});
					setLoadingLinhaDigitavelBoleto(false);
				});
		}
	}, [handleSetAlert, session])

	const downloadQrCodeBoleto = useCallback( (id: number) => {
		if(session){
			setLoadingQrCodeBoleto(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/pessoas/clientes/qrcode-boleto/'+id, { headers })
				.then((response: any) => {

					if (response.data.dados === '') {
						handleSetAlert({
							visible: true,
							variant: 'danger',
							message: 'Problema ao buscar QR Code do boleto',
							timeout: 5000
						});
						setLoadingQrCodeBoleto(false);
						return false;
					}

					setPixModal(true);
					setPixModalQRCODE(response.data.dados);
					setLoadingQrCodeBoleto(false);
				}).catch(() => {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: 'Problema ao buscar QR Code do boleto',
					timeout: 5000
				});
				setLoadingQrCodeBoleto(false);
			});
		}
	}, [handleSetAlert, session])


	useEffect(() => {
		if (invoice.status === 'vencido') {
			setInvoiceColorBorder('border-left-danger mb-4 ms-1');
			setInvoiceColor('color-danger');
		} else if (invoice.status === 'pago') {
			setInvoiceColorBorder('border-left-green mb-4 ms-1');
			setInvoiceColor('color-green');
		} else {
			setInvoiceColorBorder('border-left-primary mb-4 ms-1');
			setInvoiceColor('color-primary');
		}

		if (invoice.status === 'aberto' || invoice.status === 'vencido') {
			if (invoice.id_status === 30) {
				setButtonInvoice(<Button variant="light" className="justify-content-center align-items-center d-flex" disabled={true}><span className="material-icons title-icon">schedule</span>Processando Pagamento</Button>);
			} else {
				if (invoice.boleto === 1 && invoice.cobranca_entrada_confirmada === 1 && invoice.id_cobranca_registro_lancamento !== null) {
					setButtonInvoice(<><Button variant="light" className="justify-content-center align-items-center d-flex" onClick={() => downloadBoleto(invoice.id)}>{loadingDowloadBoleto ? <Spinner animation="border" role="status"/> : <><span className="material-icons title-icon">download</span>Imprimir Boleto</>}</Button>
						<Button variant="light" className="mt-3 justify-content-center align-items-center d-flex" onClick={() => downloadQrCodeBoleto(invoice.id)}>{loadingQrCodeBoleto ? <Spinner animation="border" role="status"/> : <><span className="material-icons title-icon">pix</span>Pagar via PIX</>}</Button>
					</>);
				} else if (invoice.boleto === 1 && invoice.cobranca_entrada_confirmada === 1) {
					setButtonInvoice(<><Button variant="light" className="justify-content-center align-items-center d-flex" onClick={() => downloadBoleto(invoice.id)}>{loadingDowloadBoleto ? <Spinner animation="border" role="status"/> : <><span className="material-icons title-icon">download</span>Imprimir Boleto</>}</Button>
						<Button variant="light" className="mt-3 justify-content-center align-items-center d-flex" onClick={() => downloadLinhaDigitavelBoleto(invoice.id)}>{loadingLinhaDigitavelBoleto ? <Spinner animation="border" role="status"/> : <><span className="material-icons title-icon">content_copy</span>Copiar Código do Boleto</>}</Button>
					</>);
				} else if (invoice.boleto === 0 && actualDate >= invoice.data_vencimento.split('-')[0] + invoice.data_vencimento.split('-')[1]) {
					setButtonInvoice(<Link to={`pagamento/${invoice?.id}`}><Button variant="light" className="w-100 justify-content-center align-items-center d-flex"><span className="material-icons title-icon">monetization_on</span>Pagar Online</Button></Link>);
				}
			}
		}
	}, [invoice, actualDate, downloadBoleto, downloadLinhaDigitavelBoleto, downloadQrCodeBoleto, loadingDowloadBoleto, loadingLinhaDigitavelBoleto, loadingQrCodeBoleto])

	return(
		<>
			<Row className={invoiceColorBorder}>
				<Col md={8} sm={12} xs={12}>
					<p><b>DATA VENCIMENTO {formatDate(invoice.data_vencimento)}</b></p>
					<p>{invoice.plano}</p>
					<p>{invoice.numero_documento}</p>
					<p><b className={invoiceColor}>R$ { (invoice.valor_total).toFixed(2) }</b></p>
				</Col>
				<Col md={4} sm={12} xs={12} className="align-self-center text-center d-grid">{buttonInvoice}</Col>
			</Row>

			{/* PAGAMENTO PIX */}
			<Modal show={pixModal} onHide={() => {return false}} aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header className="justify-content-center border-bottom-0">
					<Modal.Title id="contained-modal-title-vcenter">
						Pagamento PIX
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="show-grid">
					<Container>
						<div>
							<Row>
								<Col md={12}>
									<Col md={12}>
										<h6 className="text-center">Utilize o PIX QRCODE abaixo ou o PIX COPIA E COLA para efetuar o pagamento no aplicativo do seu banco digital</h6>
									</Col>
									<Col md={12} className="mt-4">
										<h6 className="text-center">PIX QR CODE</h6>
									</Col>
									<Col md={12} className="text-center justify-content-center d-flex mt-4">
										<QRCode value={pixModalQRCODE ? pixModalQRCODE : ''} size={250}/>
									</Col>
									<Col md={12} className="mt-4">
										<h6 className="text-center">PIX COPIA E COLA</h6>
									</Col>
									<Col md={12} className="mt-4">
										<p className="text-center text-break">{pixModalQRCODE}</p>
										<CopyToClipboard
											text={pixModalQRCODE ? pixModalQRCODE : ''}
											onCopy={() => {
												handleSetAlert({
													visible: true,
													variant: 'success',
													message: "Código copiado com sucesso",
													timeout: 5000
												});
											}
											}
										>
											<Button variant="primary d-flex justify-content-center" className="w-100">Copiar</Button>
										</CopyToClipboard>
									</Col>
								</Col>
							</Row>
						</div>
					</Container>
				</Modal.Body>
				<Modal.Footer className="border-top-0">
					<Button variant="light" onClick={() => setPixModal(false)}>Fechar</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}
